var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "airliner 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5713 1.52148L17.0469 1.78406L13.0356 5.10567L9.85651 4.54444L7.08733 4.05359L4.53807 3.60101L2.7959 5.08588L9.89829 8.34546L5.64953 13.5157C5.53737 13.6274 5.43533 13.7382 5.3456 13.8482L2.69122 12.7697L1.42847 14.0325L4.2667 15.3331L4.38589 15.4523L3.48952 16.4366L3.899 16.8096L4.77778 15.8441L5.12085 16.1868L6.31675 18.4805L7.48714 17.3079L6.1219 14.6082C6.1914 14.5598 6.25869 14.5066 6.31895 14.4442L11.8318 10.1131L11.9061 10.187L15.6117 17.5362L16.9136 15.9761L16.3818 13.2527L15.851 10.5314L15.1503 6.94372L15.1288 6.92085L18.2177 3.22275L18.5713 1.52148Z",
    fill: "#1D4650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.0ee2411434a18e66ec1ee80bfcda0c5b.svg";
export { ForwardRef as ReactComponent };